<template>
  <div class="mine-wrap container">
    <action-bar class="action-bar" title="会员资讯">
      <span slot="left"></span>
      <span slot="right"></span>
    </action-bar>

    <div class="v-main">
      <ul class="tab">
        <router-link tag="li" :to="tab.path" v-for="(tab, index) in tabs" :key="'tab' + index">{{tab.title}}</router-link>
      </ul>

      <router-view></router-view>

    </div>

  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import {MiniHorn, MiniHornItem} from 'mini-horn';
  import ActionBar from '@/components/action-bar';
  export default {
    name: "v-main",
    components: {
      ActionBar,
    },
    data () {
      return {
        tabValue: 1
      }
    },
    computed: {
      tabs () {
        return [
          {
            value: 1,
            path: '/home/mine/message',
            title: '会员资讯',
          },
          {
            value: 2,
            path: '/home/mine/update',
            title: '修改密码'
          },
          {
            value: 3,
            path: '/home/mine/center',
            title: '消息中心'
          }
        ]
      }
    },
    methods: {
      changeTabValue (e) {
        this.tabValue = parseInt(e.target.dataset.value);
      }
    }
  }
</script>

<style scoped lang="less">
  .router-link-active{
    color: #ba142b;
    border-bottom: 8px solid #ba142b;
  }
  .mine-wrap{
    font-size: 24px;
    .v-main{
      .tab{
        display: flex;
        padding: 0 10px;
        background-color: #fff;
        >li{
          width: 160px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/mine/index.vue